import { Button, Col, Form, Row, Select, Space, notification, Drawer, Avatar, message, Tooltip } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { AntInput } from "../../../shared/widges/antinput";
import { AntTextAreas } from "../../../shared/widges/anttextArea";
import { CoreServices } from "../../../base/service/apiServices";
import _ from "lodash";
import styles from "./scss/creat_form.module.scss";
import Loaders from "../../loader/loader";
import React from "react";
import { useDispatcher } from '../../../custom_hooks/use_app_dispatch';
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import ReactPhoneInput from "react-phone-input-2";
import { supervisorContactDataSliceActions } from "../../../store/slices/supervisor_contact/contactsData";
import { useNavigate } from "react-router-dom";
import { ApiServices } from '../../../services/api_services'
import { useSearchParams } from 'react-router-dom';
import { COREURL } from "../../../constants/api_constants";
import { useSelector } from "react-redux";
import countyNumCheck from './countryNumberLength'
import CustomFormDetails from "./custom_form";
import "react-phone-input-2/lib/style.css";
import { FBIdPattern, hassAccess, isJSON } from "../../../base/utils";
import { postcodeValidator } from "../../../constants/base/utils";

const CreateForm = (props: any) => {

  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [selectedState, setSelectedState] = useState<any>(null);
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [tag, setTag] = useState<any>({});
  const [tagStatus, setStatusTag] = useState<any>({});
  const [type, setType] = useState<any>({});
  const [form] = Form.useForm();
  const [emailArrayData, setEmailArrayData] = useState<any>([{ 'email': '' }])
  const [phoneArrayData, setPhoneArrayData] = useState<any>([{ 'number': '' }])
  const [oldData, setOldData] = useState<any>(null)
  const [loading, setLoading] = useState<any>(false);
  const navigate = useNavigate()
  const [phoneErrorIndex, setPhoneErrorIndex] = useState<any>([])
  const [contactTableData, setcontactTableData] = useState([]);
  const [socialTableData, setSocialTableData] = useState([]);
  const [addressTableData, setAddressTableData] = useState([]);
  const [searchParams] = useSearchParams();
  const [duplicateEmailContact, setDuplicateEmailContacts] = useState<any>([])
  const [duplicatePhoneContact, setDuplicatePhoneContacts] = useState<any>([])
  const [customFormData, setCustomFormData] = useState({});
  const [dupEmailOpen, setDupEmailOpen] = useState<any>(false)
  const [dupPhoneOpen, setPhoneOpen] = useState<any>(false)

  const [currentEmail, setCurrentEmail] = useState<any>(null)
  const [currentPhone, setCurrentPhone] = useState<any>(null)
  const [selectedValue, setSelectedValue] = useState({}) as any;
  const [phoneEditable, setPhoneEditable] = useState<any>(true)
  const [emailEditable, setemailEditable] = useState<any>(true)

  const [invalidNum, setInvalidNum] = useState<any>(false)
  const [countryData,setCountryData]=useState<any>([])
  const [stateData,setStateData]=useState<any>([])
  const [cityData,setCityData]=useState<any>([])

  const [showSave , setShowSave] = useState(false);

  const isContactEditOpen = GetItemFromStorage("isUpdate");
  const dispatch = useDispatcher()
  const dummy = {
    firstName: "",
    lastName: "",
    phoneNumber: [],
    email: [],
    tags: [],
    customerType: '',
    location: "",
    address: "",
    country: "",
    state: "",
    city: "",
    postalCode: "",
    facebook: "",
    instagram: "",
    whatsapp: "",
    twitter: "",
    voiceBiometric: "",
    timeZone: ''
  }
  const [profile, setProfile] = useState<any>(null);

  const getParticularData = async () => {
    if(props.customerID){
    await CoreServices.get(`/get_customer_conatct_details/${props.customerID}`).then(async (value) => {
      if (value && value.data.statusCode === 200) {
        const customerFullData = value.data.getContactDetailsRes[0]
        const phone: any = []
        const email: any = []
        let parsedEmailArray: any = []
        let parsedPhArray: any = []
        let customerTagData: any = []

        if (customerFullData?.email !== null && customerFullData?.email !== ''
          && customerFullData?.email !== 'undefined' && customerFullData?.email !== undefined) {
          try { parsedEmailArray = JSON.parse(customerFullData?.email) }
          catch (error) {
            if (customerFullData.email !== null && customerFullData.email !== undefined
              && customerFullData.email !== 'undefined' && customerFullData.email !== 'null') {
              parsedEmailArray = [customerFullData.email].filter((d: any) => d !== null && d !== 'null' && d !== 'undefined' && d !== undefined)
            }
          }
          parsedEmailArray?.forEach((row: any) => {
            if (row !== 'undefined' && row !== null) {
              const item = { 'email': row }
              email.push(item)
              setEmailArrayData(email)
            }
          })
          if (email?.length > 0) {
            setemailEditable(false)
          }
        }

        if (customerFullData?.phoneNumber !== null && customerFullData?.phoneNumber !== ''
          && customerFullData?.phoneNumber !== 'undefined' && customerFullData?.phoneNumber !== undefined) {
          try { parsedPhArray = JSON.parse(customerFullData?.phoneNumber) }
          catch (error) {
            if (customerFullData.phoneNumber !== null && customerFullData.phoneNumber !== undefined
              && customerFullData.phoneNumber !== 'undefined' && customerFullData.phoneNumber !== 'null') {
              parsedPhArray = [customerFullData.phoneNumber].filter((d: any) => d !== null && d !== 'null' && d !== 'undefined' && d !== undefined)
            }
          }
          parsedPhArray?.forEach((row: any) => {
            if (row !== 'undefined') {
              const item = { 'number': row }
              phone.push(item)
              setPhoneArrayData(phone)
            }
          })
          if (phone?.length > 0) {
            setPhoneEditable(false)
          }
        }

        try { 
          customerTagData = isJSON(customerFullData.tags) ? JSON.parse(customerFullData.tags) 
                              : customerFullData?.tags?.split()?.filter((B :any)=> JSON.parse(B)) 
        }
        catch { 
          customerTagData = customerFullData.tags ? [customerFullData.tags] : [] 
        }


        if (customerFullData?.country) {
          const country = countryData.filter((data: any) => customerFullData?.country === data.name)
          setSelectedCountry(country[0])

          if (country && customerFullData?.state) {
            const state = stateData.filter((data: any) => customerFullData?.state === data.name)
            setSelectedState(state[0])
          }
        }

        const newData = {
          coid: customerFullData.coid,
          firstName: customerFullData.firstName !== 'undefined' && customerFullData.firstName !== 'null' && customerFullData.firstName ? customerFullData.firstName : '',
          lastName: customerFullData.lastName !== 'undefined' && customerFullData.lastName !== 'null' && customerFullData.lastName ? customerFullData.lastName : '',
          address: customerFullData.address !== 'undefined' && customerFullData.address !== 'null' && customerFullData.address ? customerFullData.address : '',

          blockCustomer: customerFullData.blockCustomer,
          blockCustomerReq: customerFullData.blockCustomerReq,
          doNotDisturb: customerFullData.doNotDisturb,
          doNotDisturbReq: customerFullData.doNotDisturbReq,

          city: customerFullData.city !== 'undefined' && customerFullData.city !== 'null' && customerFullData.city ? customerFullData.city : '',
          country: customerFullData.country !== 'undefined' && customerFullData.country !== 'null' && customerFullData.country ? customerFullData.country : '',
          customerType: customerFullData.customerType !== 'undefined' && customerFullData.customerType !== 'null' && customerFullData.customerType ? customerFullData.customerType : '',
          facebook: customerFullData.facebook !== 'undefined' && customerFullData.facebook !== 'null' && customerFullData.facebook ? customerFullData.facebook : '',
          instagram: customerFullData.instagram !== 'undefined' && customerFullData.instagram !== 'null' && customerFullData.instagram ? customerFullData.instagram : '',
          location: customerFullData.location !== 'undefined' && customerFullData.location !== 'null' && customerFullData.location ? customerFullData.location : '',
          phoneNumber: phone ?? [],
          email: email ?? [],
          tags: customerTagData ?? [],
          postalCode: customerFullData.postalCode !== 'undefined' && customerFullData.postalCode !== 'null' && customerFullData.postalCode ? customerFullData.postalCode : '',
          state: customerFullData.state !== 'undefined' && customerFullData.state !== 'null' && customerFullData.state ? customerFullData.state : '',
          voiceBiometric: customerFullData.voiceBiometric !== 'undefined' && customerFullData.voiceBiometric !== 'null' && customerFullData.voiceBiometric ? customerFullData.voiceBiometric : '',
          whatsapp: customerFullData.whatsapp !== 'undefined' && customerFullData.whatsapp !== 'null' && customerFullData.whatsapp ? customerFullData.whatsapp : '',
          mergeCustomer: customerFullData?.mergeCustomer
        };

        const oldData = {
          coid: customerFullData?.coid,
          firstName: customerFullData?.firstName ?? '',
          lastName: customerFullData?.lastName ?? '',
          phoneNumber: parsedPhArray ?? [],
          email: parsedEmailArray ?? [],
          tags: customerTagData ?? [],
          location: customerFullData?.location ?? '',
          address: customerFullData?.address ?? '',
          country: customerFullData?.country ?? '',
          state: customerFullData?.state ?? '',
          city: customerFullData?.city ?? '',
          postalCode: customerFullData?.postalCode ?? '',
          facebook: customerFullData?.facebook ?? '',
          instagram: customerFullData?.instagram ?? '',
          whatsapp: customerFullData?.whatsapp ?? '',
          twitter: customerFullData?.twitter ?? '',
          voiceBiometric: "",
          customerType: customerFullData?.customerType ?? '',

        }
        getCountryData(customerFullData?.country,customerFullData?.state)
        setOldData(oldData)
        setProfile(newData)
      }

    });
    handleCheck()
  }
  };
  const emailValidator = async (emailCheck: any) => {
    const dupArr = [] as any
    let profile :any= {}
    setProfile((prev :any)=> {
              profile = prev;
              return prev;
    })
    if (!emailCheck) {
      setDuplicateEmailContacts([]);
      return false
    }

    else {
      await CoreServices.get(`/get_customer_contact_by_email/${emailCheck}`).then((value: any) => {
        if (value && value.data.statusCode === 200 && value.data.getContactEmailRes.length > 0) {
          value.data.getContactEmailRes?.forEach((data: any, i: any) => {
            if (profile?.coid !== data?.coid) {
              const email3 = JSON.parse(data?.email)
              if (email3.some((d: any) => d.toLowerCase() === emailCheck?.toLowerCase())) {
                dupArr.push(data)
              }
            }
          })
          if (dupArr.length > 0) {
            setDuplicateEmailContacts(dupArr);
            setCurrentEmail(emailCheck)
            setDupEmailOpen(true)
          }
          else {
            setDuplicateEmailContacts([]);
            setCurrentEmail(null)
            setDupEmailOpen(false)
          }
        }
        else {
          setDuplicateEmailContacts([])
          setCurrentEmail(null)
          setDupEmailOpen(false)
        }
      }).catch((e) => {
        console.log('email api', e)
        setDuplicateEmailContacts([])
        setCurrentEmail(null)
        setDupEmailOpen(false)
      })
    }
    return true

  }
  const phoneNumberValidator = async (phoneCheck: any) => {
    const pDupArr = [] as any
    let profile :any= {}
    setProfile((prev :any)=> {
              profile = prev;
              return prev;
    })
    if (!phoneCheck) {
      return false
    }
    else {
      await CoreServices.get(`/get_customer_contact_by_phonenumber/${phoneCheck}`).then((value: any) => {
        if (value && value.data.statusCode === 200 && value.data.getContactPhoneNumberRes.length > 0) {
          value.data.getContactPhoneNumberRes?.forEach((data: any, i: any) => {
            if (profile?.coid !== data?.coid) {
              const phone2 = JSON.parse(data?.phoneNumber)
              if (phone2.some((d: any) => d.toLowerCase() === phoneCheck?.toLowerCase())) {
                pDupArr.push(data)
              }
            }
          })
          if (pDupArr.length > 0) {
            setDuplicatePhoneContacts(pDupArr);
            setCurrentPhone(phoneCheck)
            setPhoneOpen(true)
          }
          else {
            setDuplicatePhoneContacts([]);
            setCurrentPhone(null)
            setPhoneOpen(false)
          }
        } else {
          setDuplicatePhoneContacts([]);
          setCurrentPhone(null)
          setPhoneOpen(false)
        }

      }).catch((e) => {
        console.log('phone api', e)
        setDuplicatePhoneContacts([]);
        setCurrentPhone(null)
        setPhoneOpen(false)
      })
      return true
    }
  }


  const contact_Fdata = useSelector((store: any) => store.supervisorContactData.currentFormData)
  const setExistFormData = () => {
    setProfile(contact_Fdata)
    setEmailArrayData(contact_Fdata.email)
    setPhoneArrayData(contact_Fdata.phoneNumber)
    emailValidator(contact_Fdata.invalidEmail)
    phoneNumberValidator(contact_Fdata.invalidPhone)
    dispatch(supervisorContactDataSliceActions.setFormData({}))
  }
  useEffect(() => {
    if (!_.isEmpty(contact_Fdata)) {
      setExistFormData()
    }
    else if (props.edit_create === 'edit') {
      getParticularData()
    }
    else {
      setProfile(dummy)
      setEmailArrayData([{ 'email': '' }])
      setPhoneArrayData([{ 'number': '' }])
    }
    getCustomContactField();
    tags();
    types();
    getCountryData('','')
    if(isContactEditOpen == "1") {
      setShowSave(true)
    }
  }, [props.customerID]);

  const getCountryData=(countryName:any,stateName:any)=>{
    try {
      CoreServices.get('/get_country_config').then((res:any)=>{
        if(res?.data?.statusCode===200 && res?.data?.getList?.length>0){
          const data=res?.data?.getList?.map((row:any)=>({ name: row.countryname, value: row.countryname, isoCode: row.isoCode }))
          setCountryData(data)
          if(countryName!==''){
            const countryData=data.filter((row:any)=>row?.name===countryName)
            if(countryData.length>0){
              getStateData(countryData[0]?.isoCode,stateName)
            }
          }
        }
      })      
    } catch (error) {
      console.log(error)
    }
  }
  const getStateData=(countryCode:any,stateName:any)=>{
    try {
      CoreServices.post({countryCode},'/get_state_config').then((res:any)=>{
        if(res?.data?.statusCode===200 && res?.data?.result?.length>0){
          const data=res?.data?.result?.map((row:any)=>({ name: row.statename, value: row.statename, isoCode: row.isoCode }))
          setStateData(data)
          if(stateName!==''){
            const stateData=data.filter((row:any)=>row?.name===stateName)
            if(stateData.length>0){
              getCityData(countryCode,stateData[0]?.isoCode)
            }
          }
        }else{
          setStateData([])
        }
      })      
    } catch (error) {
      console.log(error)
    }
  }
  const getCityData=(countryCode:any,stateCode:any)=>{
    try {
      CoreServices.post({countryCode,cityCode:stateCode},'/get_city_config').then((res:any)=>{
        if(res?.data?.statusCode===200 && res?.data?.result?.length>0){
          const data=res?.data?.result?.map((row:any)=>({ name: row.statename, value: row.statename, isoCode: row.id }))
          setCityData(data)
        }else{
          setCityData([])
        }
      })      
    } catch (error) {
      console.log(error)
    }
  }

  const tags = () => {
    CoreServices.get(`/get_customer_tag`).then((value: any) => {
      if (value && value.data.statusCode === 200) {
        const CustomTag = value.data.getCustomerTagListRes;
        const CustomTagStatus =value.data.getCustomerTagStatus;
        let x: any = CustomTag.filter((data: any) => data.status === 1);
        setTag(x);
        setStatusTag(CustomTagStatus);
      }
    })
  };
  const types = () => {
    CoreServices.get(`/get_customer_type_list`).then((value: any) => {
      if (value && value.data.statusCode === 200) {
        const CustomType = value.data.getCustomerTypeListRes;
        console.log("CustomType",CustomType)
        let x: any = CustomType.filter((data: any) => data.isStatus === 1);
        setType(x);
      }
    })
  };
  const setCurrentFormData = async (id: any) => {

    const body = {
      coid: profile?.coid ?? 0,
      firstName: profile.firstName,
      lastName: profile.lastName,
      phoneNumber: phoneArrayData,
      email: emailArrayData,
      tags: profile.tags ?? "",
      location: profile.location ?? "",
      address: profile.address ?? "",
      country: profile.country ?? "",
      state: profile.state ?? "",
      city: profile.city ?? "",
      postalCode: profile.postalCode ?? "",
      facebook: profile.facebook ?? "",
      instagram: profile.instagram ?? "",
      whatsapp: profile.whatsapp ?? "",
      twitter: profile.twitter ?? "",
      voiceBiometric: "",
      customerType: profile.customerType,
      invalidEmail: currentEmail,
      invalidPhone: currentPhone

    };
    dispatch(supervisorContactDataSliceActions.setFormData(body))
    navigate(`/contactsdetail?coid=${id}`)
  }

  const saveBtn = () => {
    if (dupEmailOpen || dupPhoneOpen) {
      if (dupPhoneOpen) {
        notification.error({
          message: "Phone number Already in Exist Customer",
          placement: "topRight",
          className: "toastNotification error",
          icon: <span className="icon__Error24" />,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
          </svg>,
          duration: 3,
          top: 70,
        })
      }
      else if (dupEmailOpen) {
        notification.error({
          message: "Email Already in Exist Customer",
          placement: "topRight",
          className: "toastNotification error",
          icon: <span className="icon__Error24" />,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
          </svg>,
          duration: 3,
          top: 70,
        })
      }
      return
    }
    form.validateFields()
    if (!dupEmailOpen && !dupPhoneOpen) {
      form.validateFields().then((_: any) => {
        const email_data: any = []
        const phone_data: any = []

        emailArrayData.forEach((data: any) => {
          if (data.email !== "") {
            email_data.push(data.email)
          }
        })

        phoneArrayData.forEach((data: any) => {
          if (data.number !== '') {
            phone_data.push(data.number)
          }
        })
        let concatenatedKeys = '';
        let concatenatedValues = '';
        if(Object.keys(customFormData)?.length > 0){
           concatenatedKeys = Object.keys(customFormData).join('|');
           concatenatedValues = Object.values(customFormData).map(value => `"${value}"`).join('|');
        }
        const body = {
          coid: profile?.coid ?? 0,
          firstName: profile.firstName,
          lastName: profile.lastName,
          phoneNumber: phone_data?.slice(1)?.length > 0 ? phone_data?.slice(1) : null,
          email: email_data.slice(1)?.length > 0 ? email_data.slice(1) : null,
          primaryPhoneNumber: phone_data[0],
          primaryEmail: email_data[0],
          tags: profile.tags ?? "",
          location: profile.location ?? "",
          address: profile.address ?? "",
          country: profile.country ?? "",
          state: profile.state ?? "",
          city: profile.city ?? "",
          postalCode: profile.postalCode ?? "",
          facebook: profile.facebook ?? "",
          instagram: profile.instagram ?? "",
          whatsapp: profile.whatsapp ?? "",
          twitter: profile.twitter ?? "",
          voiceBiometric: "",
          customerType: profile.customerType,
          customField : concatenatedKeys ?? null,
          customValues : concatenatedValues ?? null
        };

        if (oldData && props.edit_create === 'edit' && JSON.stringify(body) === JSON.stringify(oldData)) {
          props.onClose()
          return
        }
        else {
          setLoading(true)
        }

        console.log('tableData::::::::2222', concatenatedKeys, concatenatedValues, body);

        CoreServices.post(body, "/insert_update_customer_contact").then((response: any) => {
          if (response.data.statusCode === 200) {
            notification.info({
              message: `"${profile.firstName} ${profile.lastName}"  ${props?.edit_create === 'edit' ? "Contact updated successfully" : "Contact created successfully"}`,
              placement: "top",
              className: "toastNotification success mobnotification",
              icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
              </svg>,
              closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
              </svg>,
              duration: 3,
              top: 70,
            });
            if (isContactEditOpen === "1" && props.customerID) {
              const queryparams = props.customerID;
              ApiServices.get(COREURL, `/get_customer_conatct_details/${queryparams}`, 30000)
                .then((res: any) => {
                  if (res?.data.statusCode === 200) {
                    const channel = new BroadcastChannel("customer_update");
                    const message = {
                      type: 'customer_data',
                      data: res?.data?.getContactDetailsRes[0]
                    };
                    channel.postMessage(message);
                    dispatch(supervisorContactDataSliceActions.setContactRefresh())
                    props.onClose()
                  }else {
                    props.onClose()
                  }
                })
                .catch((error: any) => {
                  props.onClose()
                });
            } else {
              dispatch(supervisorContactDataSliceActions.setContactRefresh())
              props.onClose()
            }
          }

        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          setLoading(false)
        })

      }).catch((e) => {

        const isInvalidnum = e?.errorFields?.some((i :any)=> i.errors[0] === "Invalid phone number")
        const isInvalidEmail = e?.errorFields?.some((i :any)=> i.errors[0] === 'Invalid email id')
        console.log("isInvalidnum", isInvalidnum, isInvalidEmail, e?.errorFields)
        if(
          ((isInvalidnum && isInvalidEmail) && e?.errorFields?.length !== 2 )
          || ((isInvalidnum || isInvalidEmail) && e?.errorFields?.length !== 1 )
        ){
          notification.error({
            message: "Please enter mandatory fields",
            placement: "topRight",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          })
        }
      })
    }

  }


  const getCustomContactField = () => {
    CoreServices.get(`/get_custom_contact`)
      .then((resp: any) => {
        const conatactResponse = [] as any;
        const addressResponse = [] as any;
        const socialResponse = [] as any;
        resp?.data?.result[0]?.map((list: any) => {
          if (list?.columnCategory === "Contact" && list?.isDisplay == 1) {
            conatactResponse.push(list)
          }
          if (list?.columnCategory === "Address" && list?.isDisplay == 1) {
            addressResponse.push(list)
          }
          if (list?.columnCategory === "social" && list?.isDisplay == 1) {
            socialResponse.push(list)
          }
        })
        setcontactTableData(conatactResponse);
        setAddressTableData(addressResponse);
        setSocialTableData(socialResponse)
      })
  }

  const handleCheck = useCallback(_.debounce(() => {
    if(isContactEditOpen == "1") {
      return
    };
    const values = form.getFieldsValue();
    console.log("valuesvalues", values)
    const feilds = ['first_name', 'last_name', 'Email', 'phonenumber']
    const isValid = Object.entries(values).every(
      ([key, value]) =>
        !feilds.some(
          (pattern) => key.includes(pattern) && !value
        )
    );
    setShowSave(isValid);
  }, 200),
  [profile]
);

  const mergeModel = () => {
    if(props?.onMerge) props?.onMerge()
  }

  const debouncedNumValidator = useRef(_.debounce((val: string) => { phoneNumberValidator(val); }, 300)).current;
  const debouncedEmailValidator = useRef(_.debounce((val: string) => { emailValidator(val); }, 300)).current;

  return (
    <>
      {loading && <Loaders />}
      {profile && <Drawer title="Customer Information " className={`myActivityDrawer createformdrawerwidth contactdrawer`} width={672} placement="right" open={props.open}>
        <div className="">
          <div className={styles.drawerHeader}>
            Customer Information
            {props?.enableMerge
              ? <span className={styles.mergecontspan} style={{ display: "flex", alignItems: "center", gap: "8px" }} onClick={mergeModel}>
                <span className={styles.cursorspan}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 17 17" fill="none">
                      <path d="M15.7512 8.18211L9.2444 8.18661V1.68475C9.2444 1.27072 8.90874 0.935059 8.49471 0.935059C8.08069 0.935059 7.74503 1.27072 7.74503 1.68475V8.18771L1.24723 8.19221C0.833207 8.19251 0.497747 8.52837 0.498047 8.9424C0.498347 9.35643 0.834207 9.6919 1.24823 9.6916L7.74503 9.6871V16.189C7.74503 16.603 8.08069 16.9387 8.49471 16.9387C8.90874 16.9387 9.2444 16.603 9.2444 16.189V9.6861L15.7522 9.6816C16.1662 9.6813 16.5017 9.34544 16.5014 8.93141C16.5011 8.51738 16.1652 8.18181 15.7512 8.18211Z" fill="black" />
                    </svg>
                </span>
                <span style={{ cursor: "pointer" }}>Merge with existing contact</span>
              </span>
              : null}
              <span className="icon__Close16" onClick={() => props.onClose()} />
          </div>

          <div className={`scroller ${styles.drawerBody}`}>
            <Form name="basic" form={form} onValuesChange={handleCheck}>

              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={12}>
                  <label>First name <span className="reqStart">*</span></label>
                  <Form.Item
                    name={"first_name"}
                    initialValue={profile?.firstName}
                    rules={[
                      {
                        required: true,
                        message: "Please enter first name!",
                      },
                      {
                        pattern: /^[A-Za-z\s]+$/gm,
                        message: "Numeric & Special Characters are Not Allowed.",
                      },
                    ]}
                  >
                    <AntInput
                      className="textBox"
                      maxLength={50}
                      onChange={(e: any) =>
                        setProfile({
                          ...profile,
                          firstName: e.target.value?.charAt(0).toUpperCase() + e.target.value?.slice(1),
                        })
                      }
                      onBlur={(e: any) =>
                        setProfile({
                          ...profile,
                          firstName: e.target.value?.charAt(0).toUpperCase() + e.target.value?.slice(1),
                        })
                      }
                      placeHolder="First name"
                      onKeyDown={(e: any) => {
                        if (e.which === 13) {
                          e.preventDefault();
                        } else if (e.target.value.length < 1 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>

                  <p></p>
                </Col>
                <Col span={12}>
                  <label>Last name <span className="reqStart">*</span></label>
                  <Form.Item
                    name={"last_name"}
                    initialValue={profile?.lastName}
                    rules={[
                      {
                        required: true,
                        message: "Please enter last name!",
                      },
                      {
                        pattern: /^[A-Za-z\s]+$/gm,
                        message: "Numeric & Special Charecters are Not Allowed.",
                      },
                    ]}
                  >
                    <AntInput
                      className="textBox"
                      maxLength={50}
                      placeHolder="Last name"
                      onChange={(e: any) =>
                        setProfile({
                          ...profile,
                          lastName: e.target.value?.charAt(0).toUpperCase() + e.target.value?.slice(1),
                        })
                      }
                      onKeyDown={(e: any) => {
                        if (e.which === 13) {
                          e.preventDefault();
                        } else if (e.target.value.length < 1 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                  <p></p>
                </Col>
              </Row>
              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={24} >
                  <label>Phone Number {isContactEditOpen !== "1" && <span className="reqStart">*</span>}</label>

                  {profile && phoneArrayData?.map((row: any, index: any) => {
                    return (
                      <div key={index}>
                        <Form.Item
                          className="nobtm"
                          initialValue={row.number}
                          validateTrigger={['onChange', 'onBlur']}
                          name={`phonenumber${index}`}
                          rules={[
                            {
                              async validator(e, r) {
                                if (e.validateTrigger == "onChange") {
                                  const pattern = /^\d{10,15}$/;
                                  const value = phoneArrayData[index].number.replace(/[^\d]/g, '')
                                  try {
                                    if (value.length > 7) {
                                      debouncedNumValidator(value)
                                    }
                                    if (!value && isContactEditOpen !== "1") {
                                      setPhoneErrorIndex([...phoneErrorIndex, index])
                                      return Promise.reject("Enter phone number");
                                    }
                                    // else if (!pattern.test(value) && value !== '' && value.length >= 7) {
                                    //   setPhoneErrorIndex([...phoneErrorIndex, index])
                                    //   return Promise.reject("Invalid phone number [10-15] Only Allowed");
                                    // }
                                    else if (pattern.test(value) && phoneArrayData.find((d: any, i: any) => d.number === value && i === index)) {
                                      if (phoneArrayData.find((d: any, i: any) => d.number === value && i < index)) {
                                        setPhoneErrorIndex([...phoneErrorIndex, index])
                                        return Promise.reject("Phone Number alredy Entered");
                                      }
                                    }
                                    else {
                                      return Promise.resolve();
                                    }
                                  }
                                  catch (err) { console.log("Invalid Number error:", err) }
                                }
                              }, validateTrigger: 'onChange'
                            },
                            {
                              async validator(e, r) {
                                if (e.validateTrigger == "onBlur") {
                                  const c_number = phoneArrayData[index]
                                  const value = c_number?.number.replace(/[^\d]/g, '')
                                  // if (invalidNum) {
                                  // const data_1 =value?.replace(invalidNum.code,'')
                                  // console.log('invalidNum',invalidNum,value,data_1)
                                  // if(data_1 && data_1.length < invalidNum?.len){
                                  if(c_number?.dialCode === '91' && value && value.length !== 12){
                                    setPhoneErrorIndex([...phoneErrorIndex, index])
                                    return Promise.reject("Invalid phone number");
                                  }
                                  else if (value && value.length < 8) {
                                    setPhoneErrorIndex([...phoneErrorIndex, index])
                                    return Promise.reject("Invalid phone number");
                                  }
                                  return Promise.resolve()
                                  // }    
                                }


                              }, validateTrigger: 'onBlur'
                            }
                          ]}>
                          <div className={`${styles.customerphoneicons}`}>
                            <ReactPhoneInput
                              inputProps={{
                                name: `phonenumber${index}`,
                              }}
                              searchClass={`tableSearch`}
                              searchStyle={{ border: 0 }}
                              enableSearch
                              disabled={(index === 0 && !phoneEditable) ? true : false}
                              enableLongNumbers={15}
                              value={row.number}
                              containerClass={`topbarCallInput22  ${(phoneErrorIndex?.includes(index) || (row.number === currentPhone)) ? 'error-border' : ''}`}
                              inputClass="cusInputFlag"
                              country='gb'
                              placeholder="Enter Phone number"
                              onChange={(e: any, d: any) => {
                                const arr = phoneErrorIndex.filter((d: any) => d !== index)
                                setPhoneErrorIndex([...arr])
                                const num = e.replace(/[^\d]/g, '')
                                const data = _.cloneDeep(phoneArrayData)
                                data[index].number = num
                                data[index].country = d?.name
                                data[index].dialCode = d?.dialCode
                                setPhoneArrayData(data)

                                // if (d?.name) {
                                //   let country = d?.name
                                //   const data = countyNumCheck.find((e: any) => e.country === country)
                                //   setInvalidNum({ 'len': data?.phoneNumberLengthByCountry_phLength, 'code': d?.dialCode })
                                // }
                              }}
                            />
                            {index > 0 && <span key={`${index}span`} className="icon__circleminusicon20" onClick={() => {
                              const data = _.cloneDeep(phoneArrayData)
                              if (phoneArrayData[index].number === currentPhone) {
                                setDuplicatePhoneContacts([])
                                setPhoneOpen(false)
                              }
                              const eData = phoneErrorIndex.filter((d: any) => d !== index)
                              setPhoneErrorIndex(eData)
                              data.splice(index, 1)
                              setPhoneArrayData(data)
                              form.validateFields([`phonenumber${0}`])
                            }} />}
                          </div>
                        </Form.Item>
                        <>
                          {(row.number === currentPhone) ?
                            <div className={styles.phoneError}>Phone number already exists</div> : <></>}
                        </>
                      </div>
                    )
                  })}
                  <p className="linkinline">
                    <span className="linkText" onClick={() => {
                      const data = _.cloneDeep(phoneArrayData)
                      data.push({ 'number': '' })
                      setPhoneArrayData(data)
                    }} >Add phone number</span>
                  </p>
                </Col>
              </Row>
              {duplicatePhoneContact.length > 0 &&
                duplicatePhoneContact.map((data: any, i: any) => {
                  return (
                    <Row gutter={24} className={`${styles.grd}`}>
                      <div className={styles.duplicateContact}>
                        <p>Contact already exist</p>
                        <div className={styles.contactStripe}>
                          <div className={styles.tableUser}>
                            <div>
                              <Avatar shape="square" size={32} className={`${styles.usericon1} commoncolor randomclr${(i + 1) % 8}`}>
                                {data?.firstName ? (data?.firstName?.charAt(0).toUpperCase() + data?.lastName?.charAt(0).toUpperCase()) : 'N'}
                              </Avatar>
                            </div>
                            <div>
                              <span className={styles.userName}>{data?.firstName || "New Customer" + ' ' + (data?.lastName != 'null' && data?.lastName ? data?.lastName : ' ')}</span>
                              <span className={styles.number}>{currentPhone}</span>
                            </div>
                          </div>
                        </div >
                        <span className={styles.clickToView} onClick={() => { setCurrentFormData(data?.coid) }}>Click to view contact</span>
                      </div>
                    </Row>
                  )
                })
              }
              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={24}>
                  <label>Email {isContactEditOpen !== "1" && <span className="reqStart">*</span>}</label>
                  {profile && emailArrayData.map((email_data: any, index: any) => {
                    return (
                      <div key={index}>
                        <Form.Item
                          validateTrigger={['onChange', 'onBlur']}
                          initialValue={email_data.email}
                          name={`Email${index}`}
                          className="nobtm"
                          rules={[{
                            validator(e) {
                              const value = emailArrayData[index]?.email?.toLowerCase()
                              try {
                                const pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                                if (pattern.test(value)) {
                                  // emailValidator(value)
                                  debouncedEmailValidator(value)
                                }

                                if (pattern.test(value) && emailArrayData.find((d: any, i: any) => d.email?.toLowerCase() === value && i < index)) {
                                  return Promise.reject("Email already Entered Above");
                                }

                                return Promise.resolve();
                              }
                              catch (err) { console.log("Invalid email error:", err) }
                            }, validateTrigger: 'onChange'
                          }, {
                            validator(e) {
                              const value = emailArrayData[index]?.email?.toLowerCase()?.trim()
                              // const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
                              const pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              if (!value && isContactEditOpen !== "1") {
                                return Promise.reject("Please enter Email id!");
                              }
                              else if (value && !pattern.test(value) && isContactEditOpen !== "1") {
                                return Promise.reject("Invalid email id");
                              }
                              return Promise.resolve()
                            }, validateTrigger: 'onBlur'
                          }
                          ]}>
                          <div className={`${styles.customerphoneicons} customerphoneiconsindex`}>
                            <AntInput
                              disabled={(index === 0 && !emailEditable) ? true : false}
                              className="textBox"
                              name={`Email${index}`}
                              status={profile?.invalidEmail?.toLowerCase() === email_data?.email?.toLowerCase() || currentEmail?.toLowerCase() === email_data?.email?.toLowerCase() ? 'error' : ''}
                              value={email_data.email}
                              placeHolder="Email"
                              maxLength={254}
                              onChange={(e: any) => {
                                const pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                // const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/
                                if (pattern.test(e.target.value) && emailArrayData[index].email !== e.target.value) {
                                  setDupEmailOpen(false)
                                  setDuplicateEmailContacts([])
                                  debouncedEmailValidator(e.target.value)
                                }
                                const data = _.cloneDeep(emailArrayData)
                                data[index].email = e.target.value?.toLowerCase()
                                setEmailArrayData(data)
                              }}
                            />
                            {index > 0 && <span key={`${index}span`} className="icon__circleminusicon20" onClick={() => {
                              if (emailArrayData[index].email === currentEmail) {
                                setDuplicateEmailContacts([])
                                setDupEmailOpen(false)

                              }
                              const data = _.cloneDeep(emailArrayData)
                              data.splice(index, 1)
                              setEmailArrayData(data)
                              form.validateFields([`Email${index}`])
                            }} />}
                          </div>
                        </Form.Item>
                        {currentEmail?.toLowerCase() === email_data?.email?.toLowerCase() ?
                          <div className={styles.phoneError}>Email ID already exists</div> : <></>}

                      </div>
                    )
                  })}
                  <p className="linkinline">
                    <span className="linkText" onClick={() => {
                      const data = _.cloneDeep(emailArrayData)
                      data.push({ 'email': '' })
                      setEmailArrayData(data)
                    }} >Add email address</span>
                  </p>
                </Col>
              </Row>
              {duplicateEmailContact.length > 0 &&
                duplicateEmailContact.map((data: any, i: any) => {
                  return (
                    <Row gutter={24} className={`${styles.grd} grdcreatecont`}>
                      <div className={styles.duplicateContact}>
                        <p>Contact already exist</p>
                        <div className={styles.contactStripe}>
                          <div className={styles.tableUser}>
                            <div>
                              <Avatar shape="square" size={32} className={`${styles.usericon1} commoncolor randomclr${(i + 1) % 8}`}>
                                {data?.firstName ? (data?.firstName?.charAt(0).toUpperCase() + data?.lastName?.charAt(0).toUpperCase()) : 'N'}
                              </Avatar>
                            </div>
                            <div>
                              <span className={styles.userName}>{data?.firstName ? (data?.firstName + ' ' + data?.lastName ?? '') : "New Customer"}</span>
                              <span className={styles.number}>{currentEmail}</span>
                            </div>
                          </div>
                        </div >
                        <span className={styles.clickToView} onClick={() => { setCurrentFormData(data?.coid) }}>Click to view contact</span>
                      </div>
                    </Row>
                  )
                })
              }
              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={12}>
                  <label>Customer Type</label>
                  <Form.Item
                    initialValue={profile?.customerType !== '' ? profile?.customerType : null}
                    name={"Choose Type"}
                  >
                    <Select
                      className="antSelect"
                      placeholder="customer type"
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="antSelectPopover"
                      suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                        <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                      </svg>}
                      onChange={(value: any) => {
                        setProfile({ ...profile, customerType: value });
                      }}

                      options={type?.length > 0
                        ? type?.map((item: any) => ({
                          label: item.customerTypeName,
                          value: item.customerTypeName,
                        }))
                        : []
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <label>Tags
                  <Tooltip title="Tags are displayed based on the Customer Tags configured in Settings." placement="top">
                    <span className="icon__Info16"></span>
                  </Tooltip>
                  </label>
                  
                  <Form.Item
                    name={"tags"}
                    initialValue={profile?.tags ?? null}
                    rules={[
                      {
                        required: false,
                        message: "Please select tags!",
                      },
                    ]}
                  >
                    <Select
                      mode={"multiple"}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="antSelectPopover"
                      suffixIcon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="6"
                          viewBox="0 0 12 6"
                          fill="none"
                        >
                          <path
                            d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z"
                            fill="#757676"
                          />
                        </svg>
                      }
                      showArrow={true}
                      onChange={(value: any) => { setProfile({ ...profile, tags: value }) }}
                      className="antSelect"
                      placeholder="Select tags"
                      disabled={tagStatus === 0}
                      options={tag?.length > 0
                        ? tag?.map((item: any) => ({
                          label: item.customerTagName,
                          value: item.customerTagName,
                        }))
                        : []
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className={styles.createformmain}>
               {contactTableData?.length > 0 && <CustomFormDetails tableData={[contactTableData, setCustomFormData, selectedValue, setSelectedValue, customFormData]} />}
              </div>
              <p className={styles.titleTextsm}>Address Details</p>

              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>

                <Col span={12}>
                  <label>Country</label>
                  <div>
                    <Form.Item >
                      <Select
                        notFoundContent={'No Country Found'}
                        showSearch={true}
                        options={countryData}
                        defaultValue={profile?.country !== '' ? profile?.country : null}
                        value={profile?.country !== '' ? profile?.country : null}
                        onChange={(item: any, total: any) => {
                          form.validateFields(['postalcode'])
                          setProfile({
                            ...profile,
                            country: item,
                            state: '',
                            city:''
                          });
                          setSelectedCountry(total);
                          setSelectedState(null);
                          setSelectedCity(null);
                          getStateData(total?.isoCode,'')
                        }}
                        placeholder="Select Country"
                        className="antSelect selectcloseicon"
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName="antSelectPopover tickrightremove"
                        suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                          <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                        </svg>}
                      ></Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <label>State</label>
                  <div>
                    <Form.Item  >
                      <Select
                        notFoundContent={'No State Found'}
                        showSearch={true}
                        options={stateData}
                        defaultValue={selectedState?.name !== '' ? selectedState?.name : null}
                        value={profile?.state !== '' ? profile?.state : null}
                        onChange={(item: any, total: any) => {
                          setProfile({
                            ...profile,
                            state: item,
                            city: '',
                          });
                          setSelectedCity(null);
                          setSelectedState(total);
                          getCityData(selectedCountry?.isoCode,total?.isoCode)
                        }}
                        placeholder="Select State"
                        getPopupContainer={(trigger) => trigger.parentNode}
                        className="antSelect selectcloseicon"
                        popupClassName="antSelectPopover tickrightremove"
                        suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                          <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                        </svg>}

                      ></Select>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={12}>
                  <label>City</label>
                  <div>
                    <Form.Item >
                      <Select
                        notFoundContent={'No City Found'}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        showSearch={true}
                        options={cityData}
                        defaultValue={profile?.city !== '' ? profile?.city : null}
                        value={selectedCity?.name}
                        onChange={(item: any, total: any) => {
                          setProfile({
                            ...profile,
                            city: item,
                          });
                          setSelectedCity(total);
                        }}
                        placeholder="Select City"
                        className="antSelect selectcloseicon"
                        //  allowClear
                        popupClassName="antSelectPopover tickrightremove"
                        suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                          <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                        </svg>}
                      // value={language}
                      // onChange={changeLanguage}
                      ></Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <label>Location</label>
                  <Form.Item
                    initialValue={profile?.location}>

                    <AntInput
                      maxLength={100}
                      className="textBox"
                      defaultValue={profile?.location}
                      placeHolder="Location"
                      onChange={(e: any) => setProfile({ ...profile, location: e.target.value })}
                    />
                  </Form.Item>
                </Col>


              </Row>

              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={24}>
                  <label>Address</label>
                  <div className="textareacustommain">
                    <Form.Item
                      initialValue={profile?.address}>
                      <AntTextAreas
                        className=""
                        defaultValue={profile?.address}
                        onChange={(e: any) =>
                          setProfile({
                            ...profile,
                            address: e.target.value,
                          })
                        }
                        value={profile?.address}
                        placeHolder="Enter Address"
                        maxLength={150}
                      />
                      <div className={styles.addcount}>{profile?.address.length} / 150</div>
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>

                <Col span={12}>
                  <label>Postal Code</label>
                  <Form.Item
                    initialValue={profile?.postalCode}
                    name={"postalcode"}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[
                      {
                        validator() {
                          return Promise.resolve();
                        }, validateTrigger: 'onChange',
                      },
                      {
                        validator(_, value) {
                          try {
                            const cc = countryData.find((i: any) => profile?.country === i.name)?.isoCode;
                            const trimmed = profile?.postalCode?.toString()?.trim();
                            if (trimmed && !cc) {
                              return Promise.reject("Please select country code");
                            } else if (trimmed && cc && !postcodeValidator(trimmed, cc)) {
                              return Promise.reject("Invalid postal code");
                            }
                            return Promise.resolve();
                          } catch (err) {
                            console.log("Invalid Postal code error:", err);
                          }
                        },  validateTrigger: 'onBlur', 
                      }
                    ]}
                  >
                    <AntInput
                      maxLength={15}
                      defaultValue={profile?.postalCode}
                      className="textBox"
                      placeHolder="PostalCode"

                      onChange={(e: any) =>
                        setProfile({
                          ...profile,
                          postalCode: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className={styles.createformmain}>
              {addressTableData?.length > 0 && <CustomFormDetails tableData={[addressTableData, setCustomFormData, selectedValue, setSelectedValue, customFormData]} />}
              </div>
             {/* {hassAccess('Contact/Create') && <> */}
             <p className={styles.titleTextsm}>Social Media</p>
              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
                <Col span={12}>
                  <label>Whatsapp</label>
                  <Form.Item
                    initialValue={profile?.whatsapp}
                    name={"whatsapp"}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[
                      // {
                      //   validator(_, value) {
                      //     try {
                      //       if (profile?.whatsapp && profile?.whatsapp.toString().trim()) {
                      //         if (!indianPhoneCheck(profile?.whatsapp)) {
                      //           return Promise.reject("+ and Numeric Characters Only Allowed");
                      //         }
                      //       }
                      //       return Promise.resolve();
                      //     } catch (err) { console.log("Invalid whatsapp number error:", err) }
                      //   }, validateTrigger: 'onChange'
                      // },{
                      //   validator(_, value) {
                      //     try {
                      //       if (profile?.whatsapp && profile?.whatsapp.toString().trim()) {
                      //         if (!indianPhoneCheck(profile?.whatsapp)) {
                      //           return Promise.reject("+ and Numeric Characters Only Allowed");
                      //         }else if (profile?.whatsapp?.length < 8) {
                      //           return Promise.reject("Invalid whatsapp number");
                      //         }
                      //       }
                      //       return Promise.resolve();
                      //     } catch (err) { console.log("Invalid whatsapp number error:", err) }
                      //   }, validateTrigger: 'onBlur'
                      // },
                      {
                        async validator(e, r) {
                          if (e.validateTrigger == "onBlur") {
                            const value = profile?.whatsapp.replace(/[^\d]/g, '')
                            if(profile?.whatsappDialCode === '91' && value && value.length !== 12){
                              setInvalidNum(true)
                              return Promise.reject("Invalid phone number");
                            }
                            else if (value && value.length < 8) {
                              setInvalidNum(true)
                              return Promise.reject("Invalid phone number");
                            }
                            setInvalidNum(false)
                            return Promise.resolve()
                          }
                        }, validateTrigger: 'onBlur'
                      }
                    ]}
                  >
                    {/* <AntInput
                      maxLength={50}
                      className='textBox'
                      placeHolder="Enter Whatsapp Number"
                      value={profile?.whatsapp !== 'undefined' && profile?.whatsapp ? profile?.whatsapp : ''}
                      // onChange={(e: any) => setProfile({ ...profile, whatsapp: (e.target.value)?.trim()?.replace('+', '') })}
                      onChange={(e: any) => {
                        setProfile({ ...profile, whatsapp: e.target.value.trim().replace('+', '') });
                      }}
                    /> */}

                      <ReactPhoneInput
                        inputProps={{
                          name: `whatsapp`,
                        }}
                        searchClass={`tableSearch`}
                        searchStyle={{ border: 0 }}
                        enableSearch
                        enableLongNumbers={15}
                        value={profile?.whatsapp !== 'undefined' && profile?.whatsapp ? profile?.whatsapp : ''}
                        containerClass={`topbarCallInput22  ${ invalidNum ? 'error-border' : ''} ${invalidNum}`}
                        inputClass="cusInputFlag"
                        country='gb'
                        placeholder="Enter Whatsapp number"
                        onChange={(e: any, d: any) => {
                          const num = e.replace(/[^\d]/g, '')
                          setInvalidNum(false)
                          setProfile({ ...profile, whatsapp: num, whatsappDialCode: d?.dialCode });                           
                        }}
                      />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <label>Instagram</label>
                  <Form.Item
                    initialValue={profile?.instagram}
                    name={"instagram"}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[{
                        validator(_, value) {
                          try {
                            if (profile?.instagram?.toString()?.trim()) {
                              if (!/^\d{2,35}$/.test(value)) {
                                return Promise.reject("Instagram ID must be 2–35 digits");
                              }
                            }
                            return Promise.resolve();
                          } catch (err) { console.log("Invalid Instagram Id error:", err) }
                        }, validateTrigger: 'onBlur'
                      },
                    ]}
                  >
                  <AntInput
                    className='textBox'
                    placeHolder="Enter Instagram Id"
                    value={profile?.instagram}
                    maxLength={50}
                    onChange={(e: any) => {
                      const numericOnly = e.target.value.replace(/[^0-9]/g, "");
                      setProfile({ ...profile, instagram: numericOnly });
                    }}
                        onKeyDown={(e: any) => {
                          const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                          if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                  />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} className={`${styles.grd} grdcreatecont`}>
              <Col span={12}>
              <label>Facebook</label>
              <Form.Item
                    initialValue={profile?.facebook}
                    name={"facebook"}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[{
                        validator(_, value) {
                          try {
                            if (value?.toString()?.trim()) {
                if (!FBIdPattern.test(value)) {
                  return Promise.reject("Invalid Facebook Id");
                }
                            }
                            return Promise.resolve();
                          } catch (err) { console.log("Invalid Facebook Id error:", err) }
                        }, validateTrigger: 'onBlur'
                      },
                    ]}
                  >
                  <AntInput
                    className='textBox'
                    maxLength={50}
                    placeHolder="Enter Facebook Id"
                    value={profile?.facebook}
                    onChange={(e: any) => {
                    const numericOnly = e.target.value.replace(/[^0-9]/g, "");
                    setProfile({ ...profile, facebook: numericOnly });
                        }}
                        onKeyDown={(e: any) => {
                          const allowedKeys = [
                            'Backspace', 
                            'Delete',
                            'ArrowLeft',
                            'ArrowRight',
                            'Tab',
                          ];
                          if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
            </Form.Item>
            </Col>
              </Row>
              {/* </>} */}
              <div className={`${styles.createformmain} ${styles.createformmainlast}`}>
                {socialTableData?.length > 0 && <CustomFormDetails tableData={[socialTableData, setCustomFormData, selectedValue, setSelectedValue, customFormData]} />}
              </div>
            </Form>

          </div>
          <Row justify="end" className={styles.end}>
            <Space >
              <Button key="cancel" className="buttonCancel" onClick={() => props.onClose()}>Cancel</Button>
              <Button key="submit" disabled={!showSave} className={styles.greenBtn} onClick={() => saveBtn()} > {props.edit_create === 'edit' ? 'Update' : 'Save'} </Button>
            </Space>
          </Row>
        </div>
      </Drawer >}
    </>
  );
}
export default React.memo(CreateForm);
